import {
  CreateReservationRecurringBookingDocument,
  CreateReservationRecurringBookingMutation,
  CreateReservationRecurringBookingMutationVariables,
} from "../GeneratedGraphQL";
import {
  defaultAvailabilityIntervalsRequestVariables,
  recurringAvailabilityIntervals,
} from "./availabilityIntervals";
import {
  defaultRecurrence,
  defaultRecurringBooking,
  noPriceRecurringBooking,
} from "./bookings";

import { defaultOrganisation } from "./organisation";
import { GraphQLError } from "graphql";
import { MockedResponse } from "@apollo/client/testing";

const availabilityRequestData = defaultAvailabilityIntervalsRequestVariables;
const selectedAvailabilityInterval = recurringAvailabilityIntervals[0];

export const defaultRecurringReservedSpaceId = "001002003004005006007090";

const organisationId = defaultOrganisation._id.toString();

const recurringReservationsRequestVariables: CreateReservationRecurringBookingMutationVariables =
  {
    input: {
      bookingIds: defaultRecurringBooking.recurring.bookings.map((b) =>
        b._id.toString(),
      ),
      expiresAfter: defaultOrganisation.reservationExpiryMinutes + 1,
      organisationId,
      recurringId: defaultRecurrence.id,
      requiredSpaces: availabilityRequestData.spaces,
      source: "mock-source",
    },
  };

export const defaultRecurringReservationResult = {
  data: {
    createReservationForRecurringBooking: {
      reservation: { start: selectedAvailabilityInterval.start },
      reservedSpace: { _id: defaultRecurringReservedSpaceId },
    },
  },
};

export const createReservationRecurringRequest: MockedResponse<CreateReservationRecurringBookingMutation> =
  {
    request: {
      query: CreateReservationRecurringBookingDocument,
      variables: recurringReservationsRequestVariables,
    },
    result: defaultRecurringReservationResult,
  };

const recurringReservationsAllBookingsRequestVariables: CreateReservationRecurringBookingMutationVariables =
  {
    input: {
      bookingIds: noPriceRecurringBooking.recurring.bookings.map((b) =>
        b._id.toString(),
      ),
      expiresAfter: defaultOrganisation.reservationExpiryMinutes + 1,
      organisationId,
      recurringId: noPriceRecurringBooking.recurring.id,
      requiredSpaces: availabilityRequestData.spaces,
      source: "mock-source",
    },
  };

export const createReservationRecurringAllBookingsRequest: MockedResponse<CreateReservationRecurringBookingMutation> =
  {
    request: {
      query: CreateReservationRecurringBookingDocument,
      variables: recurringReservationsAllBookingsRequestVariables,
    },
    result: defaultRecurringReservationResult,
  };

export const invalidOrAlteredCreateRecurringReservationRequest = {
  request: {
    query: CreateReservationRecurringBookingDocument,
    variables: recurringReservationsRequestVariables,
  },
  result: {
    data: null,
    errors: [new GraphQLError("Response code 422 (Unprocessable Entity)")],
  },
};

export const failedCreateRecurringReservationRequest = {
  request: {
    query: CreateReservationRecurringBookingDocument,
    variables: recurringReservationsRequestVariables,
  },
  result: {
    data: null,
    errors: [
      new GraphQLError("Could not create recurring booking reservation"),
    ],
  },
};
